import React, { useState } from "react";
import { useForm } from "react-hook-form";
import forgetpasword_image from "../../assets/images/Auth/forget.png";
import logo from "../../assets/images/Auth/tt-logo.png";
import arrow from "../../assets/images/Auth/back_arrow.png";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../apis/apiService";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const response = await forgotPassword(data.email);
      // setSuccessMessage(response.message); // Display success message
      toast.success("Password reset link sent to your email");
    } catch (error) {
      toast.error(error.message || "The selected email is invalid");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="container-fluid ">
        <div className="row ">
          {/* Image Section */}
          <div className="col-md-7 text-center p-5 login_bg">
            <img
              src={forgetpasword_image}
              alt="Illustration"
              className="Authleft_img"
            />
          </div>

          {/* Form Section */}
          <div className="col-md-5 p-5">
            <div className="text-center">
              <img src={logo} alt="logo" />
            </div>
            <div className="my-4 form_title">
              <div className="d-flex">
                <a className="back_btn" onClick={() => navigate("/Login")}>
                  <img src={arrow} alt="arrow" className="" />
                </a>
                <h3>Forgot Password</h3>
              </div>
              <p>Here you can easily retrieve a new password.</p>
            </div>
            <h5 className="py-4">
              Enter Your Registered Email address to get Code
            </h5>

            <form onSubmit={handleSubmit(onSubmit)} className="login_form">
              {/* Email Field */}
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="example@technotackle.com"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                />
                {errors.email && (
                  <small className="text-danger">{errors.email.message}</small>
                )}
              </div>

              {/* Success Message */}
              {successMessage && (
                <div className="alert alert-success mt-3">{successMessage}</div>
              )}

              {/* Submit Button */}
              <div className="d-grid">
                <button type="submit" className="auth_btn" disabled={loading}>
                  {loading ? "Sending..." : "Send Link"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
